import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getNoShowRateOverview,
  type NoShowRateOverviewResult,
} from '@services/api/dashboard/no-show-rate.api'

export function useNoShowRateOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<NoShowRateOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getNoShowRateOverview, {
    enabled,
    queued,
  })
}
